import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../../../../../../../colorVars';
import { MultiSwitch } from '../../../../../../../../../../atomic/buttons/multiSwitch/MultiSwitch';
import { EditableTableFieldNoOnBlurUpdate } from '../../../../../../../../../../atomic/inputs/editableTableField/EditableFieldNoOnBlurUpdate';
import {
  Body3,
  fontSizes,
} from '../../../../../../../../../../atomic/text/Text';
import style from './AddGrabCents.module.css';

export const AddGrabCentsLeftBody = ({ details, setDetails }) => {
  return (
    <tbody>
      <tr>
        <td className={style.labelTd}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            Profit Unit
          </Body3>
        </td>
        <td className={style.inputTd}>
          <MultiSwitch
            labels={['Dollars', 'Percent']}
            values={['DOLLARS', 'PERCENT']}
            setValue={(value) =>
              setDetails((prev) => ({ ...prev, takeProfitMode: value }))
            }
            controlledValue={details.takeProfitMode}
          />
        </td>
      </tr>
      <tr>
        <td className={style.labelTd}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            Quantity Unit
          </Body3>
        </td>
        <td className={style.inputTd}>
          <MultiSwitch
            labels={['Qty.', 'Pct.']}
            values={['QUANTITY', 'PERCENT']}
            setValue={(value) =>
              setDetails((prev) => ({ ...prev, grabCentsMode: value }))
            }
            controlledValue={details.grabCentsMode}
          />
        </td>
      </tr>

      <tr>
        <td className={style.labelTd}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            Trail Amount
          </Body3>
        </td>
        <td className={style.inputTd}>
          <div className={style.inputWrapper}>
            {details.takeProfitMode === 'DOLLARS' ? (
              <Body3
                fontWeight={700}
                color={colors.lightGrey}
                margin="3px 3px 0 0"
              >
                $
              </Body3>
            ) : null}
            <EditableTableFieldNoOnBlurUpdate
              // inputType="number"
              fontSize={fontSizes.body3}
              value={details.takeProfitMode === 'DOLLARS' ? details.trailAmount : details.trailAmount * 100}
              setValue={(value) =>
                setDetails((prev) => ({ ...prev, trailAmount: details.takeProfitMode === 'DOLLARS' ? value : Number(value) / 100 }))
              }
              color={colors.lightGrey}
              backgroundColor="inherit"
            />
            {details.takeProfitMode === 'PERCENT' ? (
              <Body3
                fontWeight={700}
                color={colors.lightGrey}
                margin="3px 3px 0 0"
              >
                %
              </Body3>
            ) : null}
          </div>
        </td>
      </tr>
      <tr>
        <td className={style.labelTd}>
          <Body3 fontWeight={700} color={colors.lightGrey}>
            {`Trail ${
              details.grabCentsMode === 'PERCENT' ? 'Percent' : 'Quantity'
            }`}
          </Body3>
        </td>
        <td className={style.inputTd}>
          <div className={style.inputWrapper}>
            {details.grabCentsMode === 'QUANTITY' ? (
              <Body3
                fontWeight={700}
                color={colors.lightGrey}
                margin="3px 3px 0 0"
              >
                #
              </Body3>
            ) : null}
            <EditableTableFieldNoOnBlurUpdate
              inputType="number"
              fontSize={fontSizes.Body3}
              value={
                details.grabCentsMode === 'PERCENT'
                  ? details.trailPercent
                  : details.trailQuantity
              }
              setValue={(value) => {
                if (details.grabCentsMode === 'PERCENT')
                  setDetails((prev) => ({ ...prev, trailPercent: value }));
                if (details.grabCentsMode === 'QUANTITY')
                  setDetails((prev) => ({ ...prev, trailQuantity: value }));
              }}
              color={colors.lightGrey}
              backgroundColor="inherit"
            />
            {details.grabCentsMode === 'PERCENT' ? (
              <Body3
                fontWeight={700}
                color={colors.lightGrey}
                margin="3px 3px 0 0"
              >
                %
              </Body3>
            ) : null}
          </div>
        </td>
      </tr>
    </tbody>
  );
};

AddGrabCentsLeftBody.propTypes = {
  details: PropTypes.shape({
    grabCentsMode: PropTypes.string,
    trailAmount: PropTypes.any,
    trailPercent: PropTypes.any,
    trailQuantity: PropTypes.any,
    takeProfitMode: PropTypes.string,
  }),
  setDetails: PropTypes.func,
};
